/**
 * @generated SignedSource<<19c6d9856f8b2177b1547fcb22ee7b1e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignerDirectoryImageCarousel_firm$data = {
  readonly directoryProfile: {
    readonly projectCoverPhotos: ReadonlyArray<string | null> | null;
  } | null;
  readonly name: string | null;
  readonly publicProfile: {
    readonly urlLabel: string | null;
  } | null;
  readonly " $fragmentType": "DesignerDirectoryImageCarousel_firm";
};
export type DesignerDirectoryImageCarousel_firm$key = {
  readonly " $data"?: DesignerDirectoryImageCarousel_firm$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignerDirectoryImageCarousel_firm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignerDirectoryImageCarousel_firm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignFirmDirectoryProfile",
      "kind": "LinkedField",
      "name": "directoryProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "projectCoverPhotos",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignFirmPublicProfile",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DirectoryDesignFirm",
  "abstractKey": null
};

(node as any).hash = "2f3595cc69ab3849018df516f334c274";

export default node;
